<div *ngIf="formsContent.length > 0">
  <ng-container *ngFor="let formContent of formsContent">
    <app-form-constructor *ngIf="formContent" [formContent]="formContent"></app-form-constructor>
  </ng-container>
</div>
